import { AsyncPipe } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subject, asapScheduler } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { FastighetGeometry } from "~app/common/components/map/components/menu/map-fastighet/map-fastighet-models";
import { RaskRoller } from "~app/common/models/constants";
import { ILeverantorChangedEvent , LeverantorsinformationComponent } from "~app/features/virkeskop/avtal/leverantorsinformation/leverantorsinformation.component";
import { ILeverantor } from "~app/features/virkeskop/virkesleverantor/models/virkesleverantorModel";
import { canEdit, updatePermissions } from "~app/role-permissions";
import { AvtalKundComponent } from "../../skogsvardfpv/avtal/avtal-kund/avtal-kund.component";

import { AvtalMediatorService } from "../services/avtal-mediator.service";
import { LeverantorMediatorService } from "../services/leverantor-mediator.service";
import { VirkeskopValidationMessageComponent } from "../validation/validation-message/virkeskop-validation-message.component";

@Component({
    selector: "rask-leverantorer",
    templateUrl: "./leverantorer.component.html",
    styleUrls: ["./leverantorer.component.scss"],
    imports: [
        AvtalKundComponent,
        LeverantorsinformationComponent,
        VirkeskopValidationMessageComponent,
        AsyncPipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        updatePermissions({
            role: RaskRoller.role.Kopplanera,
            canEdit: false,
            canView: true
        })
    ]
})
export class LeverantorerComponent implements OnInit, OnDestroy {
    leverantorer: ILeverantor[] = [];

    protected readonly canEdit = canEdit();
    protected isSkogsvardFpv$: Observable<boolean>;

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly avtalMediatorService = inject(AvtalMediatorService);
    private readonly leverantorMediatorService = inject(LeverantorMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    addAnbudsleverantor(avtalGuid: string, lev: ILeverantor): void {
        this.leverantorMediatorService.connectVirkesleverantor(
            avtalGuid,
            lev.guid,
            lev.andelTaljare,
            lev.andelNamnare,
            lev.kontaktperson);
    }

    fastighetSelectedForImport(fastighet: FastighetGeometry) {
        this.leverantorMediatorService.fastighetSelectedForImport(fastighet);
    }

    leverantorUpdated($event: ILeverantorChangedEvent) {
        this.leverantorMediatorService.onLeverantorChanged($event);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.leverantorMediatorService.leverantorer$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(leverantorer => {
                this.leverantorer = leverantorer;
            });

        this.isSkogsvardFpv$ = this.activatedRoute.data.pipe(
            map(data => data.isSkogsvardFPV)
        );
    }

    skickadTillVacs(): boolean {
        return this.avtalMediatorService.avtal?.hasKontraktSkickatTillVacs;
    }

    tempLeverantorerChanged(leverantorer: any[]) {
        asapScheduler.schedule(() => {
            this.leverantorMediatorService.tempLeverantorerChanged(leverantorer);
        });
    }
}
